import { ruleType } from '~HIOR/constants'
import { ruleStatus } from '~HIOR/constants'

const statusLabels = {
  [ruleStatus.STATUS_UNCOMPLETED]: {
    label: 'Open',
    color: 'uncompleted'
  },
  [ruleStatus.STATUS_APPROVAL_PENDING]: {
    label: 'Wacht op toetsing',
    color: 'pending'
  },
  [ruleStatus.STATUS_APPROVED]: {
    label: 'Afgerond',
    color: 'approved'
  },
  [ruleStatus.STATUS_APPROVAL_REJECTED]: {
    label: 'Afgewezen',
    color: 'rejected'
  },
  [ruleStatus.STATUS_IRRELEVANT]: {
    label: 'N.v.t.',
    color: 'irrelevant'
  },
  [ruleStatus.STATUS_CHECKED_OFF]: {
    label: 'Open',
    color: 'uncompleted'
  },
  [ruleStatus.STATUS_REAPPROVAL_REQUESTED]: {
    label: 'Wacht op toetsing',
    color: 'pending'
  }
}

export default {
  computed: {
    $ruleTypes () {
      return [
        {
          value: ruleType.TYPE_NORMAL,
          label: 'Standaard'
        },
        {
          value: ruleType.TYPE_FLEXIBLE,
          label: 'Flexibel'
        },
        {
          value: ruleType.TYPE_CUSTOM,
          label: 'Project-specifiek'
        }
      ]
    }

  },
  methods: {
    $ruleTypeLabel (type) {
      const ruleType = this.$ruleTypes.find((ruleType) => {
        if (ruleType.value === parseInt(type)) {
          return ruleType
        }
      })

      return ruleType ? ruleType.label : null
    },
    $ruleStatusLabel (status) {
        return statusLabels[status]?.label
    },
    $ruleStatusColor (status) {
        return statusLabels[status]?.color
    },
    $ruleIsIncomplete (status) {
      return status === ruleStatus.STATUS_UNCOMPLETED
    },
    $ruleIsCheckedOff (status) {
      return status === ruleStatus.STATUS_CHECKED_OFF
    },
    $ruleIsApproved (status) {
      return status === ruleStatus.STATUS_APPROVED
    },
    $ruleIsRejected (status) {
      return status === ruleStatus.STATUS_APPROVAL_REJECTED
    },
    $ruleIsIrrelevant (status) {
      return status === ruleStatus.STATUS_IRRELEVANT
    },
    $ruleIsAwaitingApproval (status) {
      return status === ruleStatus.STATUS_APPROVAL_PENDING || status === ruleStatus.STATUS_REAPPROVAL_REQUESTED
    }
  }
}
